// extracted by mini-css-extract-plugin
export default {"wrapper":"pageLoader_wrapper__tnaP+","spinner":"pageLoader_spinner__vb0Ka","spin":"pageLoader_spin__y2SHc","srOnly":"pageLoader_srOnly__O4kon"};